import BasicRouterView from "../../components/BasicRouterView.vue";

const altRoutes = {
  path: "alt",
  redirect: { name: "alt-listar" },
  meta: {
    label: "Notificação",
    icon: "notifications",
    show: true,
    favorite: false,
  },
  component: BasicRouterView,
  children: [
    {
      path: "notificacao/listar",
      name: "alt-listar",
      meta: {
        label: "Listar Notificações",
        icon: "business",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "../alertas/listarAlertas.vue"),
    },
  ],
};

export default altRoutes;
